import React from "react";

export default function ButtonSecondary({label, onClick, icon, customClass=""}) {
    function displayIcon() {
        if (icon)
            return (icon);
    }

    return (
        <button className={`custom-btn-secondary ${customClass}`} onClick={onClick}>
            <span className="btn-icon">{displayIcon()}</span>
            <label>{label}</label>
        </button>
    )
}